import React from 'react';
import { styled } from "../../stitches.config"
import { h4Strong } from "../commonStyles/Fonts";
import PhotoOnTopCarousel from "./PhotoOnTopCarousel";

import { SimilarArticlesType } from "../../stores/ArticleStore"

type SeeAlsoArticlesProps = {
    articles: SimilarArticlesType[];
}

const SeeAlsoArticles: React.FC<SeeAlsoArticlesProps> = ({
    articles,
    ...props
}) => {
    return (
        <StyledSeeAlsoArticles>
            <Header>
                <p className={h4Strong()}>Zobacz także</p>
                <BlackLine></BlackLine>
            </Header>

            <Wrapper>
                {articles.map((article, i) =>
                    <PhotoOnTopCarousel
                        key={"similar_articles__" + i}
                        article={article}
                        dataAnalyticsName={"left-column-see-also-carousel-" + i} />

                )}
            </Wrapper>
            <BlackLine></BlackLine>
        </StyledSeeAlsoArticles>
    );
};

const StyledSeeAlsoArticles = styled('div', {
    margin: "20px 0",
    position: "relative",
    zIndex: 10,
})

const Wrapper = styled('div', {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    overflowX: "scroll",
    scrollbarWidth: "none",
    margin: "20px 0",

    "@bp4": {
        overflowX: "visible",
        flexWrap: "wrap",
        justifyContent: "space-between",
    }
})


const Header = styled('div', {
    display: "flex",
    alignItems: "center",
    "& p": {
        flexShrink: 0,
        margin: "0 16px 0 0",
        color: '$grayscale100',
    }
})

const BlackLine = styled('div', {
    borderTop: "2px solid $grayscale100",
    width: "100%",
})

export default SeeAlsoArticles